import { connect } from 'react-redux';
import CommentCell from './CommentCell';

import { getComment } from '../../../../../../../../core/selectors/comments';
import { accessingCurrentSpaceAsStaff } from '../../../../../../../../core/selectors/classroom';

const mapStateToProps = (state, ownProps) => ({
  comment: getComment(state, ownProps.id),
  isReadOnlyUser: accessingCurrentSpaceAsStaff(state),
});

const CommentCellContainer = connect(mapStateToProps)(CommentCell);

export default CommentCellContainer;
